import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react'
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom'
import { country_code_array2 } from '../functions';
import { domestic_destination_array } from '../functions';
import "react-datepicker/dist/react-datepicker.css";
import { NavLink } from 'react-router-dom';
import BACKEND_URL from '../../../api';

import '../../../My_Account.css'
import Sidebar from './Sidebar';
import { Helmet } from 'react-helmet';
import { useCountry } from '../../../context/CountryContext';

const labelstyle = {
    color: "#000 !important",
    fontSize: "13px !important"
}
export default function Domestic_quote() {
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const { selectedCountry } = useCountry();
    const navigate = useNavigate()

    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };
    const [countdiv, setcountdiv] = useState(1)
    const [countdiv_domestic, setcountdiv_domestic] = useState(1)
    function increment() {
        setcountdiv((prevCount) => prevCount + 1);

        const updatedData = { ...getQuotedata };
        updatedData.dimensions.height.push('0');
        updatedData.dimensions.length.push('0');
        updatedData.dimensions.width.push('0');
        updatedData.dimensions.weight.push('0.5');
        setgetQuotedata(updatedData);
    }
    const [countries, setcountries] = useState(country_code_array2);
    const [domesticloc, setdomesticloc] = useState(domestic_destination_array);
    const date = new Date();
    const today = date.getDay()

    const [daycount, setdaycount] = useState(0)
    const [startDate, setStartDate] = useState(today == 6 ? new Date(date.setDate(date.getDate() + 2)) : new Date(date.setDate(date.getDate() + 1)))
    const date2 = new Date();
    const today2 = date2.getDay()
    const [startDate2, setStartDate2] = useState(today2 == 6 ? new Date(date2.setDate(date2.getDate() + 2)) : new Date(date2.setDate(date2.getDate() + 1)))

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0;
    };
    const [shiptype, setshiptype] = useState('export')
    const [exportclass, setexportclass] = useState('active')
    const [importclass, setimportclass] = useState('')

    function showthisdiv(val) {
        if (val == 'exportdiv') {

            setshiptype('export')
            setexportclass('active')
            setimportclass('')
            setgetQuotedata({ ...getQuotedata, shipmenttype: val })
        } else if (val == 'importdiv') {

            setshiptype('import')
            setexportclass('')
            setimportclass('active')
            setgetQuotedata({ ...getQuotedata, shipmenttype: val })

        }


    }
    const user = sessionStorage.getItem('userid');
    const [getQuotedata, setgetQuotedata] = useState(
        {
            user: user,
            origin: 'DXB',
            destination: 'AUH',
            shipmenttype: "domestic",
            typediv: "package",
            shipping_date: startDate,
            dimensions: {
                weight: ['0.5'],
                length: ['0'],
                width: ['0'],
                height: ['0']
            }
        }
    )

    function updateweight(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.weight]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                weight: updatedAccepted
            }
        });

    }

    function updatelength(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.length]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                length: updatedAccepted
            }
        });

    }

    function updatewidth(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.width]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                width: updatedAccepted
            }
        });

    }

    function updateheight(val, i,) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.height]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                height: updatedAccepted
            }
        });

    }

    function changedate(date) {
        setStartDate(date)
        setgetQuotedata({ ...getQuotedata, shipping_date: date })
    }

    function getQuote() {
        fetch(`${BACKEND_URL}/quoteDomestic`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...getQuotedata,
                countryId: selectedCountry?.id // Add countryId for backend to use correct country config
            })
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Network response was not ok');
                }
                return res.json(); // Assuming the response is in JSON format
            })
            .then((data) => {
                // Store the quoted data in session storage
                sessionStorage.setItem('qouteinput', JSON.stringify(getQuotedata));
                // Navigate to the quotation page with the response data
                navigate('/quotation', {
                    state: {
                        basic: data.basic,
                        qoute_rate: data.rate,
                        get_gov_vat: data.charge1,
                        charge_rate: data.charge_rate,
                        es_surcharge: data.es_surcharge,
                        oversize: data.oversize,
                        er_charge: data.RD_charge,
                        user_discount: data.user_discount,
                        weight: data.weight,
                        chargable_weight: data.chargable_weight,
                        get_transit_time: data.get_transit_time,
                        user_text: data.user_text
                    }
                });
            })
            .catch(error => console.log(error.message));
    }

    function removemore(val, shiptype) {
        if (shiptype == 'domestic') {
            setcountdiv((prevCount) => prevCount - 1);

            const clonedListing = { ...getQuotedata.dimensions };
            const updatedAcceptedweight = [...clonedListing.weight]
            const updatedAcceptedlength = [...clonedListing.length]
            const updatedAcceptedwidth = [...clonedListing.width]
            const updatedAcceptedheight = [...clonedListing.height]
            updatedAcceptedweight.splice(val, 1);
            updatedAcceptedlength.splice(val, 1);
            updatedAcceptedwidth.splice(val, 1);
            updatedAcceptedheight.splice(val, 1);
            setgetQuotedata({
                ...getQuotedata,
                dimensions: {
                    ...clonedListing,
                    height: updatedAcceptedheight,
                    length: updatedAcceptedlength,
                    width: updatedAcceptedwidth,
                    weight: updatedAcceptedweight,
                }
            });
        }
    }

    function copySec(val) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAcceptedweight = [...clonedListing.weight]
        const updatedAcceptedlength = [...clonedListing.length]
        const updatedAcceptedwidth = [...clonedListing.width]
        const updatedAcceptedheight = [...clonedListing.height]
        updatedAcceptedweight[countdiv] = updatedAcceptedweight[val];
        updatedAcceptedlength[countdiv] = updatedAcceptedlength[val];
        updatedAcceptedwidth[countdiv] = updatedAcceptedwidth[val];
        updatedAcceptedheight[countdiv] = updatedAcceptedheight[val];
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                weight: updatedAcceptedweight,
                length: updatedAcceptedlength,
                width: updatedAcceptedwidth,
                height: updatedAcceptedheight
            }
        });
        setcountdiv((prevCount) => prevCount + 1);
    }
    return (
        <div className="my_parcels">
            <Helmet>
                <title>Shypv | Domestic Quote</title>
            </Helmet>
            <div className="myparctab" style={{ padding: "0" }}>

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />

                        {/* /#admin-sidebar */}
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
                            <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                    <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                        <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                            {
                                                isOpen ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-left"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                        />
                                                    </svg>
                                                )
                                            }
                                        </button>
                                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                            <ul className="navbar-nav">
                                                <>
                                                    <li className="nav-item">
                                                        <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/track">TRACK</NavLink>
                                                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                    </li>

                                                    {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                                <form method="post" action="<?php echo get_the_permalink(193); ?>" id="send_parcels">
                                    <div className="col-md-12 col-sm-12 yodeldirect" id="quote_get">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 send_a_parcel">
                                                <h3 className="comaprison_hedding">DOMESTIC QUOTE</h3>
                                                <div id="exTab1" style={{ border: " 1px solid #3c50e1" }}>
                                                    <ul className="nav nav-pills">
                                                        <li className="active"><a onClick={() => showthisdiv('exportdiv')} className="import_export" flag="export" id="export-link">Next Day</a></li>
                                                        {/* <li><a onClick={() => showthisdiv('importdiv')} className="import_export" flag="import" id="import-link">Import</a></li> */}
                                                    </ul>

                                                    {shiptype && shiptype == 'export' ? (
                                                        <div className="tab-content clearfix quotetab">
                                                            <div className="tab-pane " id="1a" style={{ background: "#fff !important", display: "block" }}>
                                                                <h3 className="section-head" style={{ fontSize: "16px", color: "#4b609b", fontWeight: "500", marginTop: "2%" }}>Where are you sending your parcels from/to?</h3>
                                                                <div className="tab-content">
                                                                    <div id="export" className="export-content">
                                                                        <ul className="business_region quotesec2 export-area">
                                                                            <li>
                                                                                <label style={{ color: "#000 !important" }}>From</label>
                                                                                <select id="export_from" className="form-control export-field from_country delivery_from" name="delivery_from" onChange={(e) => setgetQuotedata({ ...getQuotedata, origin: e.target.value })}>
                                                                                    <option value="DXB">Dubai</option>
                                                                                    <option value="AUH">Abudhabi</option>
                                                                                    <option value="SHJ">Sharjah</option>
                                                                                </select>
                                                                            </li>
                                                                            <li>
                                                                                <label >To</label>
                                                                                <select id="export_to" className="form-control export-field import-field-to to_country delivery_to" name="delivery_to" onChange={(e) => setgetQuotedata({ ...getQuotedata, destination: e.target.value })}>

                                                                                    {

                                                                                        Object.entries(domesticloc).map(([k, v]) => (
                                                                                            <option key={k} value={k} selected={k === 'AUH'}>{v}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                                <input type="hidden" name="ip_country" defaultValue className="ip_country" />
                                                                            </li>
                                                                            <p className="error" />
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {shiptype && shiptype == 'import' ? (
                                                        <div className="tab-content clearfix quotetab">
                                                            <div className="tab-pane1" id="2a">
                                                                <h3 className="section-head" style={{ fontSize: "16px", color: "#4b609b", fontWeight: "500", marginTop: "2%" }}>Where are you sending your parcels from/to?</h3>
                                                                <div className="tab-content">

                                                                    <ul className="business_region quotesec2 export-area">
                                                                        <li>
                                                                            <label>From</label>
                                                                            <select id="import_from" className="form-control import-field import-field-from to_country delivery_from" name="delivery_from" onChange={(e) => setgetQuotedata({ ...getQuotedata, origin: e.target.value })} >

                                                                                {

                                                                                    Object.entries(countries).map(([k, v]) => (
                                                                                        <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </li>
                                                                        <li>
                                                                            <label>To</label>
                                                                            <select id="import_to" className="form-control import-field from_country delivery_to" name="delivery_to" onChange={(e) => setgetQuotedata({ ...getQuotedata, destination: e.target.value })}>
                                                                                <option value="AE">Abu Dhabi</option>
                                                                                <option value="AE">Ajman</option>
                                                                                <option value="AE">Al Ain</option>
                                                                                <option value="AE" selected>Dubai</option>
                                                                                <option value="AE">Fujairah</option>
                                                                                <option value="AE">Ras Al Khaimah</option>
                                                                                <option value="AE">Sharjah</option>
                                                                                <option value="AE">Umm Al Quwain</option>
                                                                            </select>
                                                                            <input type="hidden" name="ip_country" defaultValue className="ip_country" />
                                                                        </li>
                                                                        <p className="error" />
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : null
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-sm-12 send_a_parcel send_weight quotetab">
                                            <div className="add_more_weight">
                                                {[...Array(countdiv)].map((e, i) => <><div key={i}>
                                                    <h3 className="section-head" style={{ fontSize: "16px", color: "#4b609b", fontWeight: "500", marginTop: "2%" }}>Enter the weight and dimensions of your parcels
                                                        {i > 0 ? (
                                                            <button type="button" className="removebtn" onClick={() => removemore(i, 'domestic')}>x</button>
                                                        ) : null}
                                                    </h3>
                                                    <ul className="business_region">

                                                        <li style={{ width: "24%" }}>
                                                            <label className="label--reg">Weight<span className="required">*</span> (kg)</label>
                                                            <select className="form-control weight-class weight-class-first" name="weight[]" onChange={(e) => updateweight(e.target.value, i)}>

                                                                {i > 0 ? (
                                                                    <option value="">select weight</option>
                                                                ) : null
                                                                }
                                                                <option value="0.5" selected={getQuotedata.dimensions.weight[i] === '0.5'} >0.5</option>
                                                                <option value="1" selected={getQuotedata.dimensions.weight[i] === '1'}>1</option>
                                                                <option value="1.5" selected={getQuotedata.dimensions.weight[i] === '1.5'}>1.5</option>
                                                                <option value="2" selected={getQuotedata.dimensions.weight[i] === '2'}>2</option>
                                                                <option value="2.5" selected={getQuotedata.dimensions.weight[i] === '2.5'}>2.5</option>
                                                                <option value="3" selected={getQuotedata.dimensions.weight[i] === '3'}>3</option>
                                                                <option value="3.5" selected={getQuotedata.dimensions.weight[i] === '3.5'}>3.5</option>
                                                                <option value="4" selected={getQuotedata.dimensions.weight[i] === '4'}>4</option>
                                                                <option value="4.5" selected={getQuotedata.dimensions.weight[i] === '4.5'} >4.5</option>
                                                                <option value="5" selected={getQuotedata.dimensions.weight[i] === '5'}>5</option>
                                                                <option value="5.5" selected={getQuotedata.dimensions.weight[i] === '5.5'}>5.5</option>
                                                                <option value="6" selected={getQuotedata.dimensions.weight[i] === '6'}>6</option>
                                                                <option value="6.5" selected={getQuotedata.dimensions.weight[i] === '6.5'}>6.5</option>
                                                                <option value="7" selected={getQuotedata.dimensions.weight[i] === '7'}>7</option>
                                                                <option value="7.5" selected={getQuotedata.dimensions.weight[i] === '7.5'}>7.5</option>
                                                                <option value="8" selected={getQuotedata.dimensions.weight[i] === '8'}>8</option>
                                                                <option value="8.5" selected={getQuotedata.dimensions.weight[i] === '8.5'} >8.5</option>
                                                                <option value="9" selected={getQuotedata.dimensions.weight[i] === '9'}>9</option>
                                                                <option value="9.5" selected={getQuotedata.dimensions.weight[i] === '9.5'}>9.5</option>


                                                                {[...Array(71)].map((x, k) => (
                                                                    k > 9 ? (
                                                                        <option value={k} selected={getQuotedata.dimensions.weight[i] == k} key={k} >{k}</option>
                                                                    ) : null
                                                                )
                                                                )}


                                                            </select>
                                                        </li>
                                                        <li style={{ width: "24%", marginRight: "1%" }}>
                                                            <label className="label--reg">Length (cm)</label>
                                                            <input className="form-control weight-class weight-class-first input--small" name="length[]" placeholder value={getQuotedata.dimensions.length[i]} type="number" min={0} onChange={(e) => updatelength(e.target.value, i)} />
                                                        </li>
                                                        <li style={{ width: "24%", marginRight: "1%" }}>
                                                            <label className="label--reg">Width (cm)</label>
                                                            <input className="form-control weight-class weight-class-first input--small" name="width[]" value={getQuotedata.dimensions.width[i]} placeholder type="number" min={0} onChange={(e) => updatewidth(e.target.value, i)} />
                                                        </li>
                                                        <li style={{ width: "24%", marginRight: "1%" }}>
                                                            <label className="label--reg">Height (cm)</label>
                                                            <input className="form-control weight-class weight-class-first input--small" name="height[]" value={getQuotedata.dimensions.height[i]} placeholder type="number" min={0} onChange={(e) => updateheight(e.target.value, i)} />
                                                        </li>
                                                        <a title='Duplicate this package’s info' className="copybtn" onClick={() => copySec(i)}>➕</a>
                                                    </ul>
                                                </div>
                                                </>
                                                )}
                                            </div>



                                            <div className="cross_Another_sec">+
                                                <button className="btn btn-parcels noradius" id="add_more_sizes" type="button" onClick={increment} style={{ color: "#2c4079", borderBottom: "1px solid" }}>
                                                    <div className="center-con cross_icons">
                                                        <div className="round">
                                                            <span />
                                                            <span />
                                                            <span />
                                                            <span />
                                                        </div>
                                                    </div>
                                                    Add a different size
                                                </button>
                                            </div>
                                        </div>
                                        <hr className="hr_border" />
                                        <div className="col-md-10 col-sm-10 parcel_date quotetab">
                                            <h3 className="section-head" style={{ fontSize: "16px", color: "#4b609b", fontWeight: "500", marginTop: "2%" }}>When are you shipping?</h3>
                                            <DatePicker className="form-control shipping_date" filterDate={isWeekday} minDate={startDate2} name="shipping_date" dateFormat='dd/MM/yyyy' selected={startDate}
                                                onChange={date => {
                                                    changedate(date);
                                                }} />

                                        </div>
                                    </div>
                                    <hr className="hr_border" />
                                    <div className="wrape_promo">

                                        <span className="get_center_bnts">
                                            <label className>&nbsp;</label>
                                            <button className="btn_same1" type="button" name="get_quotes" id="get_quote" onClick={getQuote}>SUBMIT</button>
                                            <input type="hidden" name="get_quote" defaultValue="Get Quote" />

                                            <input type="hidden" name="parcel_type" id="parcel_type" defaultValue="export" />
                                            <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                        </span>
                                    </div>


                                </form>
                            </div>
                        </div>


                    </div> {/* /.row */}
                </div> {/* /.container-fluid */}
            </div>
        </div>
    )
}


